import React from "react"
import Lottie from "react-lottie"

import lottiejson from "../../../data/assets/lottie.json"

const LottieContainer = React.memo(() => (
  <Lottie
    options={{
      loop: true,
      autoplay: true,
      animationData: lottiejson,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    }}
  />
))

export default LottieContainer
